import { useEffect, useRef, useState } from "react";
import * as vault from "../lib/vault";
import PinPad from "../components/PinPad";
import LockShell, { faceIdErrorMessage } from "../components/LockShell";

export default function LockScreen() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [resetKey, setResetKey] = useState(0);
  const triedFaceId = useRef(false);
  const faceId = vault.hasFaceId();

  const fail = (msg) => {
    setError(msg);
    setResetKey((k) => k + 1);
  };

  const tryFaceId = async (quiet = false) => {
    setBusy(true);
    setError("");
    try {
      await vault.unlockWithFaceId();
    } catch (err) {
      if (!quiet) setError(faceIdErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (faceId && !triedFaceId.current) {
      triedFaceId.current = true;
      tryFaceId(true);
    }
  });

  const submitPin = async (pin) => {
    setBusy(true);
    setError("");
    try {
      await vault.unlockWithPin(pin);
    } catch (err) {
      const wait = Math.ceil(vault.lockoutRemaining() / 1000);
      if (wait > 0) fail(`Too many attempts. Try again in ${wait}s.`);
      else fail("Wrong PIN");
    } finally {
      setBusy(false);
    }
  };

  const forgot = async () => {
    const ok = window.confirm(
      "There is no way to recover a forgotten PIN — your data is encrypted with it.\n\n" +
        "You can erase Nest on this phone and restore from your latest backup file. Erase now?"
    );
    if (ok) await vault.eraseEverything();
  };

  return (
    <LockShell title="Welcome back" subtitle={faceId ? "Use Face ID or enter your PIN" : "Enter your PIN"}>
      <PinPad
        onComplete={submitPin}
        onFaceId={faceId ? () => tryFaceId(false) : undefined}
        busy={busy}
        error={error}
        resetKey={resetKey}
      />
      <button
        onClick={forgot}
        className="mt-8 text-xs text-nest-muted hover:text-nest-ink"
        data-testid="forgot-pin-btn"
      >
        Forgot PIN?
      </button>
    </LockShell>
  );
}
